import namespace from '../namespace';

namespace('matterhorn.domain', (exports) => {
  // eslint-disable-next-line no-param-reassign
  exports.User = class User {
    constructor(userData) {
      this.notificationsCount = 0; // we can't rely on notifications.length due to the async behavior
      this.notifications = [];
      for (const p of [
        'clientData',
        'internal',
        'editor',
        'fromLexis',
        'anonymous',
        'email',
        'lastSeenChangeLog',
        'sessionId',
        'includeReferencesOnPrint',
        'includeReferencesOnExport',
        'locale',
        'permissions',
        'group',
      ]) {
        if (!(p in userData)) throw new Error(`Missing user data: ${p}`);
        this[p] = userData[p];
      }
      if ('agreedWithDisclaimer' in userData)
        this.agreedWithDisclaimer = userData.agreedWithDisclaimer;
    }

    addNotification(id, type, data) {
      this.notificationsCount += 1;
      import('../notification/notification-factory').then(
        ({ default: NotificationFactory }) => {
          this.notifications.push(NotificationFactory.create(id, type, data));
        }
      );
    }

    hasNotifications() {
      return this.notificationsCount > 0;
    }

    removeNotification(id) {
      let idx;
      const n = this.notifications;
      const len = n.length;
      for (let i = 0; i < len; i += 1)
        if (n[i].id === id) {
          idx = i;
          break;
        }
      if (idx == null) return;
      n.splice(idx, 1);
      this.notificationsCount -= 1;
    }
  };
});
